// import rpcjs from "rpcjs";
// console.log(rpcjs);
import {Country, City} from 'country-state-city';

/**
 * Adds two numbers together.
 * @param {Array} str The second number.
 *  @param {Array} strReplace The second number.
 *  @param {Array} strWith The second number.
 * @return {int} The sum of the two numbers.
 */
function replaceAll(str, strReplace, strWith) {
    const esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const reg = new RegExp(esc, 'ig');
    return str.replace(reg, strWith);
}
/**
 * Adds two numbers together.
 * @param {Array} val The second number.
 * @return {int} The sum of the two numbers.
 */
export async function getCountry(val) {
    return new Promise(function(resolve, reject) {
        const firstTenCountries=[[]];
        const temp =[[]];
        let countries = [[]];
        countries = Country.getAllCountries();
        const length = countries.length;
        if (val && val.length > 0) {
            for (let index=0, j=0; j<5; index++) {
                if (length === index) {
                    break;
                } else {
                    temp[index] = countries[index].name.toLowerCase();
                    if ( (temp[index].startsWith(val.toLowerCase()) === true) ||
                    (temp[index].includes(val.toLowerCase()) === true) ) {
                        firstTenCountries[j] = countries[index];
                        j++;
                    }
                }
            }
        } else {
            for (let index=0; index<5; index++) {
                firstTenCountries[index] = countries[index];
            }
        }
        resolve(firstTenCountries.map((i) => {
            let name = i.name;
            const code = i.isoCode;
            if (val && val.length > 0) {
                name = replaceAll(
                    name,
                    val,
                    '<strong>' + val + '</strong>',
                );
            }
            return {name, code};
        }));
    });
};
/**
 * Adds two numbers together.
 * @param {int} countryCode The first number.
 * @param {int} val The second number.
 * @return {int} The sum of the two numbers.
 */
export async function getCity(countryCode, val=null) {
    return new Promise(function(resolve, reject) {
        const firstFiveCity=[[]];
        const temp =[[]];
        let cities = [[]];
        if (countryCode && countryCode.length > 0) {
            cities = City.getCitiesOfCountry(countryCode);
            const length = cities.length;
            if (val && val.length > 0) {
                for (let index=0, j=0; j<5; index++) {
                    if (length === index) {
                        break;
                    } else {
                        temp[index] = cities[index].name.toLowerCase();
                        if ( (temp[index].startsWith(val.toLowerCase()) === true) ||
                        (temp[index].includes(val.toLowerCase()) === true)) {
                            firstFiveCity[j] = cities[index];
                            j++;
                        }
                    }
                }
            } else {
                for (let index=0; index<5; index++) {
                    firstFiveCity[index] = cities[index];
                }
            }
            resolve(firstFiveCity.map((i) => {
                let name = i.name;
                if (val && val.length > 0) {
                    name = replaceAll(
                        name,
                        val,
                        '<strong>' + val + '</strong>',
                    );
                }
                return {name};
            }));
        }
        return;
    });
};
/**
 * Adds two numbers together.
 * @param {int} val The second number.
 * @return {int} The sum of the two numbers.
 */
export async function getPhone(val=null) {
    return new Promise(function(resolve, reject) {
        const firstTenCountries=[[]];
        const temp =[[]];
        let countries = [[]];
        countries = Country.getAllCountries();
        const length = countries.length;
        if (val && val.length > 0) {
            if ( val.startsWith('+') === true) {
                val = val.replace('+', '');
            }
            for (let index=0, j=0; ;index++) {
                if (length === index) {
                    break;
                } else if (j===5) {
                    const phonecodeLen = countries[index].phonecode.length;
                    if (phonecodeLen === 1) {
                        temp[index] = countries[index].phonecode;
                        if (temp[index].startsWith(val) === true) {
                            firstTenCountries[0] = countries[index];
                            break;
                        }
                    }
                } else if (j<5) {
                    temp[index] = countries[index].phonecode;
                    if ( (temp[index].startsWith(val) === true) || (temp[index].includes(val) === true) ) {
                        firstTenCountries[j] = countries[index];
                        j++;
                    }
                }
            }
        } else {
            for (let index=0; index<5; index++) {
                firstTenCountries[index] = countries[index];
            }
        }
        resolve(firstTenCountries.map((i) => {
            let name = i.phonecode;
            if (val && val.length > 0) {
                name = replaceAll(
                    name,
                    val,
                    '<strong>' + val + '</strong>',
                );
            }
            name = name.replace('+', '');
            name = '+' + name;
            return {name};
        }));
    });
};
